import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../shared/common.service';
import { ToastService } from '../../shared/toast.service';
import { LoaderService } from '../../shared/loader.service';

@Component({
  selector: 'app-programs-page',
  templateUrl: './programs-page.component.html',
  styleUrls: ['./programs-page.component.scss']
})
export class ProgramsPageComponent {
  isLoading = false;

  constructor(
    private router: Router,
    private commonService: CommonService,
    private toastService: ToastService,
    private loaderService: LoaderService
  ) {}
  openGoldBrochure() {
  window.location.href = '../../../assets/Brochures/Gold package.pdf';
 }

  openPlatinumBrochure() {
  window.location.href = '../../../assets/Brochures/Platinum package.pdf';
 }


  // 🔹 Public methods bound to buttons
  goToGoldBilling(): void {
    this.navigateToBillingByPackageName('gold');
  }

  goToPlatinumBilling(): void {
    this.navigateToBillingByPackageName('platinum');
  }

  // 🔹 Shared logic to find package and go to billing
  private navigateToBillingByPackageName(name: 'gold' | 'platinum'): void {
    if (this.isLoading) return;

    this.isLoading = true;
    this.loaderService.show();

    this.commonService.getPackages().subscribe({
      next: (response: any) => {
        if (response.status === 1 && Array.isArray(response.data)) {

          const pkg = response.data.find(
            (p: any) => p.name?.toLowerCase().includes(name)
          );

          if (!pkg) {
            console.error(`${name} package not found`, response.data);
            this.toastService.showError(
              `${name.charAt(0).toUpperCase() + name.slice(1)} package is not available at the moment.`
            );
            this.finishLoading();
            return;
          }

          // Same price logic as package-selection
          const priceDisplay =
            pkg.price === 0 ? 'Custom Pricing' : `$${pkg.price}`;

          this.router.navigate(['/billing-form'], {
            queryParams: {
              packageId: pkg._id,
              package: pkg.name,
              price: priceDisplay,
              installment: pkg.installmentExist === true
            }
          });
        } else {
          console.error('Unexpected packages response', response);
          this.toastService.showError('Failed to load packages. Please try again.');
        }

        this.finishLoading();
      },
      error: (err) => {
        console.error('Failed to load packages', err);
        this.toastService.showError('Failed to load packages. Please try again.');
        this.finishLoading();
      }
    });
  }

  private finishLoading(): void {
    this.isLoading = false;
    this.loaderService.hide();
  }
}
